import React, { useContext, useState } from 'react';
import { block } from 'bem-cn';
import ReactDOM from 'react-dom';

import { ModalContext } from '../ModalProvider';
import SVG from 'components/SVG';

import './Modal.scss';

import crossSVG from '../img/cross.svg';

const b = block('modal');

const Modal = ({ content, title, isMobile, closeFunction, isPermanent = false, style }) => {
  const { closeModal } = useContext(ModalContext);

  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    if (isPermanent) return;
    setIsClosing(true);

    const closeTimeout = setTimeout(() => {
      closeModal();
      clearTimeout(closeTimeout);
      if (closeFunction) closeFunction();
    }, 175);
  };

  const layout = (
    <div onClick={handleClose} className={b({ disappearing: isClosing })}>
      <div onClick={e => e.stopPropagation()} style={style} className={b('body', { disappearing: isClosing, isMobile })}>
        <div className={b('content', { isMobile })}>{content}</div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(layout, document.getElementById('modal-root'));
};

export default Modal;
